import React from "react";
import { Flag, ShieldCheck, Wrench } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-24 h-24 bg-[#D32F2F] z-0 hidden md:block" />
            <div className="absolute -bottom-4 -right-4 border-2 border-[#0B132B] w-24 h-24 z-0 hidden md:block" />
            <img
              src="https://images.unsplash.com/photo-1758574926737-e0615e4855d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
              alt="Veteran portrait representing the owner of Veteran's Auto Repair Center"
              className="relative z-10 w-full h-[520px] object-cover grayscale-[20%]"
            />
            <div className="absolute bottom-6 left-6 z-20 bg-[#0B132B] border-l-4 border-[#D32F2F] px-5 py-4 max-w-[260px]">
              <div className="font-mono-label text-[#D32F2F] mb-1">Veteran Led</div>
              <div className="font-display text-white text-lg font-semibold leading-tight">
                Military precision. Honest prices. Local service.
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-[#D32F2F]" />
              <span className="font-mono-label text-[#D32F2F]">About the Shop</span>
            </div>
            <h2 className="font-display text-3xl md:text-5xl font-bold text-[#0B132B] leading-[1.05]">
              Built on Values That{" "}
              <span className="text-[#D32F2F]">Don't Clock Out.</span>
            </h2>
            <p className="mt-6 text-[#4A5568] text-lg leading-relaxed">
              Built on military values of honesty, discipline, and service,
              Veteran's Auto Repair Center delivers dependable automotive care
              with integrity. Our mission is simple: keep your vehicle safe
              while treating every customer like family.
            </p>

            <div className="mt-8 space-y-5">
              <div className="flex gap-4 items-start">
                <div className="shrink-0 w-11 h-11 bg-[#0B132B] flex items-center justify-center">
                  <Flag className="w-5 h-5 text-[#D32F2F]" strokeWidth={2.5} />
                </div>
                <div>
                  <h3 className="font-display font-semibold text-[#0B132B] text-lg">
                    Veteran-Owned &amp; Operated
                  </h3>
                  <p className="text-[#4A5568] text-sm md:text-base leading-relaxed mt-1">
                    Service before self applies here. We stand behind every
                    repair the same way we stood for our country.
                  </p>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="shrink-0 w-11 h-11 bg-[#0B132B] flex items-center justify-center">
                  <ShieldCheck className="w-5 h-5 text-[#D32F2F]" strokeWidth={2.5} />
                </div>
                <div>
                  <h3 className="font-display font-semibold text-[#0B132B] text-lg">
                    Integrity-First Pricing
                  </h3>
                  <p className="text-[#4A5568] text-sm md:text-base leading-relaxed mt-1">
                    No hidden fees. No unnecessary upsells. Fair quotes,
                    written estimates, and clear communication from drop-off to
                    pickup.
                  </p>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="shrink-0 w-11 h-11 bg-[#0B132B] flex items-center justify-center">
                  <Wrench className="w-5 h-5 text-[#D32F2F]" strokeWidth={2.5} />
                </div>
                <div>
                  <h3 className="font-display font-semibold text-[#0B132B] text-lg">
                    Premium Local Service
                  </h3>
                  <p className="text-[#4A5568] text-sm md:text-base leading-relaxed mt-1">
                    ASE-certified technicians, modern diagnostic equipment, and
                    a clean professional shop — right here in Madison Heights.
                  </p>
                </div>
              </div>
            </div>

            <a
              href="#contact"
              data-testid="about-cta-btn"
              className="mt-10 inline-flex items-center justify-center gap-2 bg-transparent border-2 border-[#0B132B] text-[#0B132B] hover:bg-[#0B132B] hover:text-white font-semibold py-3 px-8 rounded-none transition-colors"
            >
              Schedule Your Service
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
